
import { useContext } from 'react';
import { DashboardContext } from '../../../contextApi/DashboardContext';

export default function BranchesList({website}) {
    const {searchTerm, setSearchTerm, deployBranches} = useContext(DashboardContext);

    return (
        <div>
            <h2>הסניפים שלי</h2>
            <input id='branchList_searchInput' type='text' className='branchList_searchInput' value={searchTerm} placeholder='הקלד לחיפוש סניף' onChange={(e)=>{setSearchTerm(e.target.value)}}/>
                
            <div className='branchesList_container'>
                {deployBranches(website)}
            </div>
        </div>
    )
}
